import { InvoiceStatus } from '@/modules/finance/invoices/types';
import { InvoiceStatusDTO } from '@/modules/finance/invoices/types/dto/invoice-status.dto';

/**
 * Maps InvoiceStatusDTO from API to domain InvoiceStatus enum
 */
export const mapInvoiceStatusFromDTO = (dto: InvoiceStatusDTO): InvoiceStatus => {
  switch (dto) {
    case InvoiceStatusDTO.IN_PROGRESS:
      return InvoiceStatus.InProgress;
    case InvoiceStatusDTO.OPEN:
      return InvoiceStatus.Open;
    case InvoiceStatusDTO.PAID:
      return InvoiceStatus.Paid;
    case InvoiceStatusDTO.OVERDUE:
      return InvoiceStatus.Overdue;
    case InvoiceStatusDTO.ERROR:
      return InvoiceStatus.Error;
    default:
      return InvoiceStatus.Unknown;
  }
};

/**
 * Maps domain InvoiceStatus enum to InvoiceStatusDTO for API requests
 */
export const mapInvoiceStatusToDTO = (status: InvoiceStatus): InvoiceStatusDTO => {
  switch (status) {
    case InvoiceStatus.InProgress:
      return InvoiceStatusDTO.IN_PROGRESS;
    case InvoiceStatus.Open:
      return InvoiceStatusDTO.OPEN;
    case InvoiceStatus.Paid:
      return InvoiceStatusDTO.PAID;
    case InvoiceStatus.Overdue:
      return InvoiceStatusDTO.OVERDUE;
    case InvoiceStatus.Error:
      return InvoiceStatusDTO.ERROR;
    case InvoiceStatus.Unknown:
    default:
      throw new Error(`Cannot map unknown invoice status to DTO: ${status}`);
  }
};
